import qs from 'qs'
import instance from '@/helpers/axios'
import moment from 'moment'
import numeral from 'numeral'
import groupArray from 'group-array'

const state = {
    media_beginDate: null,
    media_lastDate: null,
    media_datasets: [],
    media_number_media: [],
    media_channels: [],
    media_engage: [],
    //v2    
    media_isLoading: false,
    media_channels_x_date: {},
    media_table: null,
    media_total: 0,
    // media_channels: [],
    // media_whom: [],
}

// getters
const getters = {
    media_date: state => {
        if (state.media_beginDate != null) {
            var _start = state.media_beginDate.split("T");
            var _end = state.media_lastDate.split("T")
            return { start: _start[0], end: _end[0] }
        } else {
            return { start: state.media_beginDate, end: state.media_lastDate }
        }
    },
    media_isLoading: state => {
        return state.media_isLoading;
    },
    media_data_date: state => {
        if (state.media_beginDate !== null) {
            var _start = state.media_beginDate.split("T");
            var _end = state.media_lastDate.split("T")
            return _start[0] + " to " + _end[0];
        }else{
            return "N/A"
        }         
    },
    media_datasets: state => {
        return state.media_datasets;
    },
    media_channels: state => {
        return state.media_channels;
    },
    media_engage: state => {
        return state.media_engage;
    },
    media_table: state => {
        return state.media_table;
    },
}

// actions
const actions = {
    // start /v2 actions
    V2getMediaDatasets(context, payload) {
        state.media_isLoading = true;
        var _params = {};
        // calulate _params from main_filters                
        var main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.start !== null && main_filters.end !== null) {
                _params.start = new Date(main_filters.start).setUTCHours(0, 0, 0, 0);
                _params.end = new Date(main_filters.end).setUTCHours(23, 59, 59, 999);
            }
            if (main_filters.location_source !== null) {
                _params.location_source = main_filters.location_source;
            }
            if (main_filters.location_destination != null) {
                _params.location_destination = main_filters.location_destination;
            }
        }
        const request = {
            params: qs.parse(_params)
        };

        //query data
        instance.get('v2/tourist/media', request)
            .then(response => {
                const {
                    date,
                    media_channels_x_date,

                } = response.data;

                state.media_beginDate = date.start;
                state.media_lastDate = date.end;
                state.media_channels_x_date = media_channels_x_date;

                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "media_channels") {
                        context.commit("V2onMediaChannels", payload);
                    } else if (stateName == "media_engage") {
                        context.commit("V2onMediaEngage", payload);
                    }
                })
                state.media_isLoading = false
            })
            .catch(error => {
                console.log(error.response, "[store/v2/tourist/media] syntax errors under instant.get");
            })
    },

    V2getMediaTableDatasets(context, payload) {
        state.media_isLoading = true

        var _params = {};
        // calulate _params from main_filters                
        var main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.start !== null && main_filters.end !== null) {
                _params.start = new Date(main_filters.start).setUTCHours(0, 0, 0, 0);
                _params.end = new Date(main_filters.end).setUTCHours(23, 59, 59, 999);
            }
            if (main_filters.location_source !== null) {
                _params.location_source = main_filters.location_source;
            }
            if (main_filters.location_destination != null) {
                _params.location_destination = main_filters.location_destination;
            }
        }

        // calulate _params from sub_filters
        // q, limit, page, sort
        _params.limit = 5;
        _params.page = 1;
        _params.sort = "-sum_media_ev";
        var sub_filter = payload.sub_filter;
        if (sub_filter !== null) {
            if (sub_filter.q !== "") {
                _params.q = sub_filter.q;
            }
            if (sub_filter.limit > 0) {
                _params.limit = sub_filter.limit;
            }
            if (sub_filter.page > 0) {
                _params.page = sub_filter.page;
            }
            if (sub_filter.sort != "") {
                _params.sort = sub_filter.sort;
            }
        }

        const request = {
            params: qs.parse(_params)
        };
    
        instance.get('v2/tourist/media/table', request)
            .then(response => {
                const { date, count, rows } = response.data;
                state.media_datasets = rows;
                state.media_total = count;
                state.media_beginDate = date.start;
                state.media_lastDate = date.end;

                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "media_table") {
                        context.commit("onMediaTable", payload);
                    }
                })

                state.media_isLoading = false
            })
            .catch(error => {
                console.log(error.response, "[store/v2/tourist/media/table] syntax errors under instant.get");
            })
    }
}

// mutations
const mutations = {
    V2onMediaChannels(state, payload) {
        // --- start dataset for stack chart
        // items = [{label1:0,label2:0,...,year:string}] 
        var colors = [];
        colors['FACEBOOK'] = '#3241a6';
        colors['INSTAGRAM'] = '#578e47';
        colors['TWITTER'] = '#cf9a41';
        colors['WEBBOARD'] = '#be4141';
        colors['WEBSITE'] = '#7d3b98';
        colors['YOUTUBE'] = '#e5e5e5';

        var rows = state.media_channels_x_date.rows;
        var items = [];
        var total = 0;
        rows.forEach(function(item, index) {
            total += item.sum_media;
            var _media_channels = item._id.media_channels.toUpperCase();
            var _item = {};
            var pos = items.map(function(e) {
                return e.date;
            }).indexOf(item._id.date);
            if (pos == -1) {
                _item['date'] = item._id.date;
                _item['FACEBOOK'] = 0;
                _item['INSTAGRAM'] = 0;
                _item['TWITTER'] = 0;
                _item['WEBBOARD'] = 0;
                _item['WEBSITE'] = 0;
                _item['YOUTUBE'] = 0;
                _item[_media_channels] = item.sum_media;
                items.push(_item);
            } else {
                _item = items[pos];
                if (_item[_media_channels] === undefined) {
                    _item[_media_channels] = item.sum_media;
                } else {
                    _item[_media_channels] += item.sum_media;
                }
                items[pos] = _item;
            }
        });

        // sort by date desc        
        items.sort(function(a, b) {
            var _a = parseInt(a.date.split("-").join(""));
            var _b = parseInt(b.date.split("-").join(""));
            return _a - _b;
        });

        // attached colors 
        items.push(colors);

        if (total == 0) {
            items = [];
        }
        state.media_channels = items;
        // --- end dataset for stack chart
    },
    V2onMediaEngage(state, payload) {
        // --- start dataset for stack chart
        // items = [{label1:0,label2:0,...,year:string}] 
        var colors = [];
        colors['FACEBOOK'] = '#3241a6';
        colors['INSTAGRAM'] = '#578e47';
        colors['TWITTER'] = '#cf9a41';
        colors['WEBBOARD'] = '#be4141';
        colors['WEBSITE'] = '#7d3b98';
        colors['YOUTUBE'] = '#e5e5e5';

        var rows = state.media_channels_x_date.rows;
        var items = [];
        var total = 0;
        rows.forEach(function(item, index) {
            total += item.sum_media_engagement;
            var _item = {};
            var _media_channels = item._id.media_channels.toUpperCase();
            var pos = items.map(function(e) {
                return e.date;
            }).indexOf(item._id.date);
            if (pos == -1) {
                _item['date'] = item._id.date;
                _item['FACEBOOK'] = 0;
                _item['INSTAGRAM'] = 0;
                _item['TWITTER'] = 0;
                _item['WEBBOARD'] = 0;
                _item['WEBSITE'] = 0;
                _item['YOUTUBE'] = 0;
                _item[_media_channels] = item.sum_media_engagement;
                items.push(_item);
            } else {
                _item = items[pos];
                if (_item[_media_channels] === undefined) {
                    _item[_media_channels] = item.sum_media_engagement;
                } else {
                    _item[_media_channels] += item.sum_media_engagement;
                }
                items[pos] = _item;
            }
        });

        // sort by date desc        
        items.sort(function(a, b) {
            var _a = parseInt(a.date.split("-").join(""));
            var _b = parseInt(b.date.split("-").join(""));
            return _a - _b;
        });

        // attached colors 
        items.push(colors);

        if (total == 0) {
            items = [];
        }

        state.media_engage = items;
        // --- end dataset for stack chart
    },
    onMediaTable(state, payload) {
        // --- start dataset for v-data-table
        /**
        {
            "_id": {
                "media_name": "jeepjee"
            },
            "sum_media_ev": 3697,
            "sum_media_like": 3671,
            "sum_media_share": 3366,
            "sum_media_comment": 3713
        }
        */
        var rows = state.media_datasets;
        var media_datatable = {
            headers: [
                { text: 'Name', value: "media_name", align: 'left' },
                { text: 'EV', value: "sum_media_ev", align: 'left' },
                { text: 'Like', value: "sum_media_like", align: 'left' },
                { text: 'Share', value: "sum_media_share", align: 'left' },
                { text: 'Comment', value: "sum_media_comment", align: 'left' },

            ],
            items: [{
                value: false,
                media_name: '',
                sum_media_ev: '',
                sum_media_like: '',
                sum_media_share: '',
                sum_media_comment: '',
            }],
            pagination: {
                sortBy: 'sum_media_ev',
                descending: true,
            },
            total: 0,
        };

        // build items
        var items = [];
        rows.forEach(function(item, index) {
            var _item = {
                value: false,
                media_name: item._id.media_name,
                sum_media_ev: item.sum_media_ev,
                sum_media_like: item.sum_media_like,
                sum_media_share: item.sum_media_share,
                sum_media_comment: item.sum_media_comment,
            }
            items.push(_item);
        });
        media_datatable.items = items;
        media_datatable.total = state.media_total;
        state.media_table = media_datatable;
        // --- start dataset for v-data-table
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}